<template>
  <div>
    <el-bread-crumb :bread-cumb="breadCrumb"/>
    <el-row class="pb20">
      <glue-export-excel :action="exportAction" :params="exportParams"/>
    </el-row>
    <el-table :data="data" v-loading="loading" border>
      <el-table-column label="用户名称" prop="nickname" width="160"></el-table-column>
      <el-table-column label="出生日期" prop="birth" width="120"></el-table-column>
      <el-table-column label="手机号" prop="mp" width="160"></el-table-column>
      <el-table-column label="地址" prop="address" width="160" show-overflow-tooltip></el-table-column>
      <el-table-column label="身份证号" prop="cert_no" width="160"></el-table-column>
      <el-table-column label="报名情况" prop="status" width="160"></el-table-column>
      <el-table-column label="签到情况" prop="sign_status" width="160">
        <template slot-scope="{row}">
          <div>-</div>
        </template>
      </el-table-column>
      <el-table-column label="评价" min-width="100">
        <template slot-scope="{row}">
          <el-link v-if="row.comment_time" type="primary" :underline="false" @click="viewComment(row)">查看</el-link>
          <div v-else>-</div>
        </template>
      </el-table-column>
    </el-table>
    <comment-detail ref="commentDetailRef"/>
  </div>
</template>

<script>
import ElBreadCrumb from '../../components/BreadCumb.vue'
import glueExportExcel from '~/components/glueExportExcel.vue'
import commentDetail from "./components/commentDetail.vue";

export default {
  name: "joinDetail",
  components: {
    ElBreadCrumb,
    glueExportExcel,
    commentDetail
  },
  data() {
    return {
      loading: false,
      data: [],
      id: '',
      exportParams: {},
      exportAction: '',
      breadCrumb: []
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.breadCrumb = [
      {'name': '活动列表', 'path': `/activity/list/${this.$route.params.ruleId}`},
      {'name': '报名详情', 'path': ''}]
    this.loadData();
    this.exportParams = {id: this.id};
    this.exportAction = this.$apiUrl.exportJoinList;
  },
  methods: {
    loadData() {
      if (this.loading) return;
      this.loading = true;
      this.$api.get_glue(this.$apiUrl.joinList, {
        id: this.id
      }, (res) => {
        this.loading = false;
        if (res.data) {
          this.data = res.data.list || [];
        } else {
          this.data = [];
        }
      }, (res) => {
        this.loading = false;
        this.data = [];
      });
    },
    viewComment(row) {
      this.$refs.commentDetailRef.open({...row, created_at: row.comment_time});
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// joinDetail.vue?25d93dde